






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('categorizedCourses', ['roughNumCourses']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class PremiumFeatures extends Vue {
  @Prop(Boolean) private readonly forFullPaywall!: boolean | undefined;

  private readonly isMobile!: MobileGetter;

  private get headingText(): string {
    if (this.isMobile(this.$mq)) {
      return 'Benefits and features';
    }
    return 'Features for subscribers only';
  }
}
